module.exports = __webpack_public_path__ + "static/media/brand-logo.c1707a71.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/brand-logo.svg
 ** module id = 189
 ** module chunks = 0
 **/